import { SinisterCaseStatus } from "../../../shared/services/api/sinister/SinisterNegotiationService";

// Lista oficial passada pela equipe de operação (ticket "Correção dos status e das ações do módulo
// de cobrança", prioridade alta) — em ordem alfabética (pedido explícito, facilita achar o item no
// select). Ver nota em SinisterCaseStatus sobre o reaproveitamento de "collection_started".
export const CASE_STATUS_OPTIONS: { value: SinisterCaseStatus; label: string }[] = [
	{ value: "duplicate_case_closed", label: "Aberto em Duplicidade - Encerrado" },
	{ value: "cash_agreement", label: "Acordo a Vista" },
	{ value: "preventive_agreement", label: "Acordo em Preventiva" },
	{ value: "installment_agreement", label: "Acordo parcelado" },
	{ value: "canceled", label: "Cancelado" },
	{ value: "debt_confession_closed", label: "Confissão de Dívidas - Encerrado" },
	{ value: "collection_started", label: "Em atuação" },
	{ value: "keys_delivered", label: "Entrega de Chaves" },
	{ value: "deceased", label: "Falecido" },
	{ value: "finalized", label: "Finalizado" },
	{ value: "finalized_pd_gei_sc", label: "Finalizado PD/GEI/SC" },
	{ value: "direct_payment", label: "Pagamento direto" },
	{ value: "partial_payment", label: "Pagamento Parcial" },
	{ value: "agreement_broken", label: "Quebra de Acordo" },
	{ value: "no_agreement_possible", label: "Sem Possibilidade de Acordo" },
	{ value: "recurring_claim_pe", label: "Sinistro Recorrente - PE" },
];

// Códigos aposentados pela lista oficial (não aparecem mais em CASE_STATUS_OPTIONS), mas podem
// existir em registros antigos de status-history gravados antes desta correção. Mantido só pra
// exibição — nunca usar como opção de formulário.
const LEGACY_CASE_STATUS_LABELS: Record<string, string> = {
	negotiating: "Em negociação",
	payment_promise: "Promessa de pagamento",
	keys_delivery_promise: "Promessa de entrega de Chaves",
	cash_payment: "Pagamento a vista (boleto, pix, cartão de crédito)",
	payment_at_agency: "Pagamento na imobiliária",
	no_contact_case: "Não conseguiu contato",
	finalized_without_indemnity: "Sinistro Finalizado sem indenização",
	collection_dropped: "Cobrança Baixada",
	fraud_suspected: "Fraude/suspeita de fraude",
	forwarded_to_post: "Encaminhado para o Pós",
	forwarded_to_legal: "Encaminhado para o Jurídico",
};

export const getCaseStatusLabel = (status: SinisterCaseStatus | string): string =>
	CASE_STATUS_OPTIONS.find((option) => option.value === status)?.label ?? LEGACY_CASE_STATUS_LABELS[status] ?? status;

// Quando a cobrança ainda não teve nenhum status registrado — não é um valor real de
// `SinisterCaseStatus` (nunca é enviado pro backend), é só o rótulo padrão exibido na UI.
export const CASE_STATUS_OPEN_LABEL = "Aberto";

export const getCaseStatusChipColors = (status?: SinisterCaseStatus | string | null): { bg: string; color: string } => {
	if (!status) return { bg: "#ECECEC", color: "#757575" };
	return { bg: "#e0faff", color: "#0f92d4" };
};
